/*
 * $Id:: DrawerSidebar.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import { IconButton, Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';

import { t } from '../../providers';
import Sidebar from '../Sidebar';

const useStyles = makeStyles((_theme) => ({
    menuButton: {
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        marginRight: '10px',
        '& svg': {
            fill: 'black',
            opacity: '.54',
            width: '24px !important',
            '&:hover': {
                opacity: '.35',
            },
        },
        '&.MuiButtonBase-root': {
            margin: '0 20px 0 0',
            '&:hover': {
                backgroundColor: '#BDE298',
            },
        },
    },
    drawer: {},
}));

const DrawerSidebar = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleSidebarVisibility = () => {
        setOpen(!open);
    };

    return (
        <div>
            <IconButton
                aria-controls="menu-container"
                aria-expanded={open}
                aria-haspopup={true}
                id="burgerMenuBtn"
                color="inherit"
                aria-label={open ? t('close.main.navigation') : t('open.main.navigation')}
                onClick={handleSidebarVisibility}
                edge="start"
                className={classes.menuButton}>
                <MenuIcon aria-hidden="true" focusable="false" />
            </IconButton>
            <Drawer className={classes.drawer} anchor="left" open={open} onClose={handleSidebarVisibility}>
                <Sidebar aria-labelledby="burgerMenuBtn" smallDevice={true} id="menu-container" handleSidebarVisibility={handleSidebarVisibility} />
            </Drawer>
        </div>
    );
};

export default DrawerSidebar;
